import { Amperes } from '@/features/execute-calculation-set/overmind/calculation/domain/ElectricCurrent';

import { AttentionStatus } from '../../../../../AttentionStatus';
import {
  EvaluationResult,
  type EvaluationResultType
} from '../../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../../RulesProvider';

export class AvailableCapacityEvaluation {
  private readonly ruleName = 'Mv_AcLineSegment_AvailableCapacity';

  constructor(private readonly rulesProvider: ForRuleProviding) {}

  public evaluate(availableCapacity: number): EvaluationResultType<Amperes> {
    const rule = this.rulesProvider.getRule(this.ruleName);
    const status = AttentionStatus.fromAlertScale(
      rule?.value,
      availableCapacity
    );
    const value = Amperes.fromAmperes(availableCapacity);
    return EvaluationResult.from(status, value, this.ruleName);
  }
}
